/**
 * QueryClient específico de Solid para `apps/web`.
 *
 * Replica las defaults de `createStandardQueryClient` (de `@comandero/shared`)
 * pero instanciando la clase `QueryClient` que exporta `@tanstack/solid-query`
 * — necesario para satisfacer el tipo del `QueryClientProvider` de Solid,
 * cuya `QueryClient` extiende la base con campos privados propios.
 *
 * Mantenemos los mismos valores que en `apps/native` (offlineFirst, retry=2,
 * staleTime de 5 minutos) para garantizar paridad de comportamiento entre
 * ambas apps.
 */

import { QueryCache, QueryClient } from "@tanstack/solid-query";
import { OFFLINE_CACHE_STALE_TIME_MS } from "./constants";

const DEFAULT_RETRY_COUNT = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "offlineFirst",
      refetchOnReconnect: true,
      retry: DEFAULT_RETRY_COUNT,
      staleTime: OFFLINE_CACHE_STALE_TIME_MS,
    },
    mutations: {
      networkMode: "offlineFirst",
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (import.meta.env.DEV) {
        console.warn("[QueryClient] error", { error, query });
      }
    },
  }),
});
